/* BSFA — FIX DEFINITIVO "tema rialzato" / pagina bloccata in alto.

   Causa: la funzione "page transition" del tema aggiunge la classe
   'm:overflow-hidden' a <html>/<body> per bloccare lo scroll mentre lo
   spinner di transizione copre lo schermo, e la rimuove via JS (theme-global.js)
   al DOMContentLoaded. Su ripristino da bfcache (tasto Indietro/Avanti) o su
   connessioni lente quella rimozione a volte NON arriva: la pagina resta
   bloccata in alto e l'overlay puo' restare visibile. Il vecchio rimedio era
   basato solo su eventi (race). Qui usiamo una GUARDIA PERMANENTE con
   MutationObserver che annulla il blocco nell'istante in cui compare, per
   sempre. NON tocca 'prevent-scroll' (usata da carrello e menu mobile). */
(function () {
  var LOCK = 'm:overflow-hidden';
  function killOverlay() {
    var ov = document.querySelector('.m-page-transition');
    if (!ov || ov.classList.contains('m-page-transition--design-mode')) return;
    ov.classList.remove('fade-in');
    ov.classList.add('fade-out');
    ov.style.opacity = '0';
    ov.style.visibility = 'hidden';
    ov.style.pointerEvents = 'none';
  }
  function unlock() {
    document.documentElement.classList.remove(LOCK);
    if (document.body) document.body.classList.remove(LOCK);
    killOverlay();
  }
  unlock();
  document.addEventListener('DOMContentLoaded', unlock);
  window.addEventListener('load', unlock);
  window.addEventListener('pageshow', unlock);   /* bfcache */
  window.addEventListener('popstate', unlock);
  setTimeout(unlock, 300);
  setTimeout(unlock, 1200);
  /* Guardia permanente: se il blocco viene (ri)aggiunto, lo togliamo subito. */
  function guard(target) {
    if (!target || !window.MutationObserver) return;
    try {
      new MutationObserver(function () {
        if (target.classList.contains(LOCK)) unlock();
      }).observe(target, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }
  function startGuards() { guard(document.documentElement); guard(document.body); }
  if (document.body) startGuards();
  else document.addEventListener('DOMContentLoaded', startGuards);
})();
